var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShirtIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 20.55L48.3949 28.7098L43.2 24.675V48.6H28.5486V48.3493C28.5486 47.2826 28.3724 46.257 28.0477 45.3H39.9V17.9336L47.8164 24.082L50.1174 21.1275L40.8465 13.9168C39.5912 15.4115 38.0796 16.4827 36.6109 17.2251C34.1636 18.4622 31.6336 18.9 30 18.9C26.3263 18.9 23.3299 17.4266 21.1887 15.6852C20.4786 15.1076 19.8341 14.4776 19.2688 13.8271L9.8867 21.1243L12.1929 24.0758L20.1 17.9315V27.8233C19.2848 27.4241 18.3682 27.2 17.3993 27.2C17.1971 27.2 16.9972 27.2098 16.8 27.2288V24.675L11.619 28.701L5.25 20.55L20.1 9C20.3645 9.76047 20.9708 10.7838 21.8784 11.7974C23.5966 13.7161 26.3949 15.6 30 15.6C31.8009 15.6 35.7385 14.7877 38.2388 11.8886C38.9257 11.0921 39.5042 10.138 39.9 9L54.75 20.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0195 38.914C20.0464 38.9013 20.0733 38.8884 20.1 38.8753V38.9224C20.0732 38.9195 20.0464 38.9167 20.0195 38.914Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8279 47.8731C26.8279 43.5338 23.3101 40.016 18.9707 40.016H15.8279C11.4885 40.016 7.97073 43.5338 7.97073 47.8731V51.016H26.8279V47.8731Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3993 29.016C20.0029 29.016 22.1136 31.1266 22.1136 33.7303C22.1136 36.3339 20.0029 38.4446 17.3993 38.4446C14.7957 38.4446 12.685 36.3339 12.685 33.7303C12.685 31.1266 14.7957 29.016 17.3993 29.016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirtIndividual);
export default __webpack_public_path__ + "static/media/shirt-individual.1b17752a.svg";
export { ForwardRef as ReactComponent };